/**
 * add accordion functionality for menu items to .s-footer selector
 */
import jQuery from 'jquery'
import * as lib from '../lib/lib'

export default class YouTubeVideo {
  constructor(element) {
    if (!element) {
      return false
    }

    /* eslint-disable camelcase */
    this.playerVars = {
      autoplay: 0,
      mute: false,
      controls: 0,
      iv_load_policy: 3,
      loop: 0,
      modestbranding: 1,
      rel: 0,
    }

    this.$element = jQuery(element)

    this.playerId = jQuery('a', this.$element).data('playerid')
    this.videoId = this.$element.data('videoid')

    if (this.$element.data('attr')) {
      this.playerVars = this.$element.data('attr')
      if (typeof this.playerVars.mobile_autoplay === 'number') {
        if (lib.scrDevices()) {
          this.playerVars.autoplay = this.playerVars.mobile_autoplay
        }
      }
    }

    if (typeof this.videoId === 'undefined') {
      return
    }
    this.iniYoutubePlayer()

    this.playerReady = false

    this.listenEventVideoPause()
  }

  listenEventVideoPause() {
    document.querySelector('body').addEventListener(
      'videoPause',
      () => {
        this.pause()
      },
      false
    )
  }

  iniYoutubePlayer() {
    const self = this
    const YT = window.YT

    this.player = new YT.Player(self.playerId, {
      videoId: self.videoId,
      playerVars: self.playerVars,
      events: {
        onReady: function () {
          self.playerReady = true
          self.elem = jQuery(`#${self.playerId}`)

          if (self.playerVars.autoplay) {
            self.hidePlayerLayer()
            self.play()
          }
        },
        onStateChange: self.onPlayerStateChange.bind(self),
      },
    })
  }

  onPlayerStateChange(event) {
    const YT = window.YT

    if (event.data === YT.PlayerState.PLAYING) {
      jQuery(document).trigger('video-playing')
    }
    if (event.data === YT.PlayerState.ENDED) {
      this.showPlayerLayer()
      jQuery(document).trigger('video-ended')
    }
  }

  hidePlayerLayer() {
    jQuery(`#${this.playerId}`).css('z-index', '0')

    jQuery(`.b-video__playBtn[data-playerid="${this.playerId}"]`)
      .parents('.b-video')
      .find('.b-video__cover')
      .fadeOut(200)
  }

  showPlayerLayer() {
    jQuery(`#${this.playerId}`).css('z-index', '-1')

    jQuery(`.b-video__playBtn[data-playerid="${this.playerId}"]`)
      .parents('.b-video')
      .find('.b-video__cover')
      .fadeIn(200)
  }

  play() {
    if (this.checkPlayer()) this.player.playVideo()
  }

  pause() {
    if (this.checkPlayer()) this.player.pauseVideo()
  }

  checkPlayer() {
    if (
      typeof this.player === 'undefined' ||
      typeof this.player.pauseVideo !== 'function'
    ) {
      return false
    }
    return true
  }

  playVideo() {
    this.hidePlayerLayer()
    this.play()
    console.log('playVideo')
  }
}
